/**
 * This file contains code responsible for loading images (it was created to load images from thum.io
 * but it will work with any image url).
 *
 * How it works:
 *
 * * Define image url as attribute `data-sd-image-load="http://url.to/my/image.jpg"`.
 * * During loading process nice loading indicator is displayed inside element.
 * * If image is loaded with http code 200 it's set as elements `background-image` css property.
 * * If image is loaded with any other http code, default image is set as elements `background-image` css property.
 *
 * How to use it:
 *
 *     <div data-sd-load-image="http://url.to/my/image.jpg" style="width: 200px; height: 200px;"></div>
 *
 * Things to do in the future:
 *
 * * Allow to specify custom default image using `data-sd-image-load-default` attribute.
 * * Allow to specify how loaded image will be displayed (background image/image element) using `data-sd-image-load-mode` attribute.
 *
 * What `sd` prefix in attribute names stands for?
 * `sd` means `solodev`.
 */

export default class LoadImage {
  constructor(){
    const els = document.querySelectorAll('[data-sd-image-load]'),
    len = els.length;
    if (len) {
      while (len--) {
          els[len].innerHTML += '<div class="sd-image-load-mask"><div class="lds-ring"><div></div><div></div><div></div><div></div></div></div>';
          this.loadImg(els[len]);
      }
    }
  }

  loadImg(el) {
    var url = el.getAttribute('data-sd-image-load'),
        // Standard XHR to load an image
        request = new XMLHttpRequest();

    // If url was not specified set default image.
    if (!url) {
        this.setImage(el, false);
        return;
    }

    // Automatically cache url to thum.io.
    if (url.indexOf('thum.io') !== -1) {
        url = '/image/get/' + btoa(url);
    }

    request.open('GET', url);
    request.responseType = 'blob';

    // When the request loads, check whether it was successful.
    request.onload = function () {
        if (request.status === 200) {
            this.setImage(el, true, url);
        } else {
            this.setImage(el, false);
        }
    };

    request.onerror = function () {
        this.setImage(el, false);
    };

    // Send the request.
    request.send();
  }

  setImage(el, success, url) {
    el.style.backgroundSize = 'cover';
    el.style.backgroundRepeat = 'no-repeat';

    if (success) {
        el.style.backgroundPosition = '0 0';
        el.style.backgroundImage = 'url("'+url+'")';
    } else {
        el.style.backgroundImage = 'url("/___/images/solodev-icon-default.png")';
        el.style.backgroundSize = 'initial';
        el.style.backgroundPosition = '50%';
    }

    var loader = el.querySelector('.sd-image-load-mask');
    if (loader) {
        loader.classList.add('sd-image-load-mask--hide');
        setTimeout(function () {
            el.removeChild(loader);
        }, 500);
    }
  }
}
